import * as React from 'react';
import { Tour3d16 } from '@cian/ui-kit';
import * as style from './TourIcon.css';

// tslint:disable:max-line-length
export const TourIcon = () => {
  return (
    <div className={style['wrapper']}>
      <Tour3d16 color={'white_100'} />
    </div>
  );
};

TourIcon.displayName = 'TourIcon';
